<div id="<%= dom_id answer %>" class="w-full sm:w-auto my-5 space-y-5">
  <div>
    <strong class="block font-medium mb-1">Person:</strong>
    <%= answer.person_id %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Question:</strong>
    <%= answer.question_id %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Answer value:</strong>
    <%= answer.answer_value %>
  </div>
</div>
